import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BasicElementModel } from 'projects/phdsoft/common/src/lib/models/basic-element.model'
import { ElementForDeletion } from 'projects/phdsoft/common/src/lib/models/element-for-deletion.model'
import { ChangeElementStatusRequest } from 'projects/phdsoft/common/src/lib/models/elements-change-status.model'
import {
  ProtectionElementsCountRequest,
  ProtectionElementsCountResult,
} from 'projects/phdsoft/common/src/lib/models/elements-count-request'
import { GenerateLabel } from 'projects/phdsoft/common/src/lib/models/generate-label'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class ElementInsertionService {
  constructor(private http: HttpClient) {}

  getAssetElements(assetId: string, regionId: string) {
    return this.http.get<BasicElementModel[]>(
      environment.API_THREED + `Elements/Element?assetId=${assetId}&regionId=${regionId}`,
    )
  }

  createElement(element: BasicElementModel) {
    return this.http.post<BasicElementModel>(environment.API_THREED + `Elements/Element`, element)
  }

  updateElement(element: BasicElementModel) {
    return this.http.put(environment.API_THREED + `Elements/Element`, element)
  }

  deleteElement(element: BasicElementModel) {
    return this.http.request('delete', environment.API_THREED + `Elements/Element`, {
      body: element,
    })
  }

  async deleteMultipleElements(assetId: string, element: ElementForDeletion[]) {
    return await this.http.request(
      'delete',
      environment.API_THREED + `Elements/MultipleElements?assetId=${assetId}`,
      { body: element },
    )
  }

  async getNextGeneratedElementLabel(generateLabel: GenerateLabel): Promise<string> {
    return this.http
      .post(environment.API_THREED + `Elements/GetNextGeneratedElementLabel`, generateLabel, {
        responseType: 'text',
      })
      .toPromise()
  }

  async countElementsByRegion(
    protectionElementsCountRequest: ProtectionElementsCountRequest,
  ): Promise<ProtectionElementsCountResult> {
    return this.http
      .post<ProtectionElementsCountResult>(
        environment.API_THREED + `Elements/CountElementsByRegion`,
        protectionElementsCountRequest,
        { responseType: 'json' },
      )
      .toPromise()
  }

  async changeElementsFromOutlinedToExecuted(
    changeElementStatusRequest: ChangeElementStatusRequest,
  ): Promise<boolean> {
    return this.http
      .post<boolean>(
        environment.API_THREED + `Elements/ChangeElementsFromOutlinedToExecuted`,
        changeElementStatusRequest,
        { responseType: 'json' },
      )
      .toPromise()
  }
}
